import React, {Component} from "react"

import MD from "@irati/ui/src/Markdown"
import {Body, H5} from "@irati/ui/src/Typography"

import ListItem from "./styled/ListItem"
import ExpandIcon from "./styled/ExpandIcon"
import ItemTopWrapper from "./styled/ItemTopWrapper"
import Icon, {IconTypes} from "../Icon"

export interface ListItem {
  title: string
  description: string
}

interface Props {
  item: ListItem
}

interface State {
  isOpen: boolean
}

class ExpandingListItem extends Component<Props, State> {
  state: State = {
    isOpen: false
  }

  doToggle = () => {
    this.setState({isOpen: !this.state.isOpen})
  }

  render() {
    const {title, description} = this.props.item
    const {isOpen} = this.state

    return (
      <ListItem direction="column">
        <ItemTopWrapper alignItems="center" onClick={this.doToggle}>
          <ExpandIcon isOpen={isOpen}>
            <Icon icon={IconTypes.chevronRight} size={16} />
          </ExpandIcon>
          <H5 marginLeft={2}>{title}</H5>
        </ItemTopWrapper>
        <Body marginLeft={7}>
          {isOpen && <MD source={description} />}
        </Body>
      </ListItem>
    )
  }
}

export default ExpandingListItem
